export default "__VITE_ASSET__BdJU0Aeb__"